import { tagReplacer2 } from "../../../utils/proposals/tag-replacer";
export var replaceTagsFromMap = function(html) {
    var valuesMap = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Object.keys(valuesMap).forEach(function(key) {
        var value = valuesMap[key];
        if (!value && value !== 0) value = "";
        html = tagReplacer2(html, key, String(value));
    });
    return html;
};
